export function range(n) {
  return Array(n).fill('_')
  // eslint-disable-next-line @typescript-eslint/naming-convention
  .map((_, i) => i);
}
//# sourceMappingURL=range.js.map